/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { FlexContainer, H2, Image, Text } from "@carrotfertility/carotene"
import { FormattedMessage, useIntl } from "react-intl"
import { Link } from "@carrotfertility/carotene-core"

export function ErrorStep(): JSX.Element {
  const intl = useIntl()

  return (
    <>
      <FlexContainer paddingTopBottom={"32px"} alignItems={"center"} direction={"column"}>
        <Image
          src={"/images/exclamation-mark-sign.png"}
          srcSet={"/images/exclamation-mark-sign-2x.png"}
          altText={intl.formatMessage({
            defaultMessage: "something's not working"
          })}
          height={"160px"}
          width={"160px"}
        />
      </FlexContainer>

      <FlexContainer stack={"tiny"} paddingLeftRight={"48px"} alignItems={"center"} direction={"column"}>
        <H2>
          <FormattedMessage defaultMessage="Something's not working" />
        </H2>
      </FlexContainer>

      <FlexContainer stack={"medium"} alignItems={"center"} direction={"column"}>
        <Text as="div" size="small">
          <FormattedMessage defaultMessage="Try reloading this page. If the problem persists, feel free to contact us at" />
        </Text>
        <Text as="div" size="small">
          <FormattedMessage
            defaultMessage="<link>support@get-carrot.com</link>"
            values={{
              link: (linkContent) => <Link href="mailto:support@get-carrot.com">{linkContent}</Link>
            }}
          />
        </Text>
      </FlexContainer>
    </>
  )
}
